import { createContext, useCallback, useState } from "react";
import * as authService from "@/services/auth";

export const AuthContext = createContext();

const DEFAULT_USER = {
  ...authService.getUser(),
};

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(DEFAULT_USER);

  const setUserInfo = useCallback((data) => {
    setUser({
      ...data,
    });
  }, []);

  const setIsSubscriptionValid = useCallback((data) => {
    setUser((prevState) => ({
      ...prevState,
      isSubscriptionValid: data,
    }));
    authService.setIsSubscriptionValid(data);
  }, []);

  const logout = useCallback(() => {
    setUser(authService.EMPTY_USER);
  }, []);
  console.log("AuthProvider user", user);

  return (
    <AuthContext.Provider
      value={{ ...user, setUserInfo, logout, setIsSubscriptionValid }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
